import {Location} from './state'
import AppState from '../../types/app-state'

export const locationsLoadingSelector = (state: AppState): boolean => state.locations.isFetching
export const locationsSelector = (state: AppState): Location[] => state.locations.locations
export const locationsRefreshedSelector = (state: AppState): boolean | null =>
    state.locations.isRefreshed
